import * as React from 'react';
import { H2, Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';

/**
 * This component will be displayed when the BE is not returning
 * any prescription ranges for a CL product.
 * If things are set up corrently, it should never be displayed.
 */ const NoRangesConfigured = ()=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(H2, {
        variant: "heading-smallest"
    }, getLabel('products.contactLenses.prescription.title')), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Alert, {
        variant: "error",
        className: "alert-m-default"
    }, getLabel('common.errors.nonrecoverable.generic'))));
};

export { NoRangesConfigured };
//# sourceMappingURL=NoRangesConfigured.js.map
